import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { sanitizeHref } from '@wix/da-url';
import Logo from '@wix/da-ds/pkg/Logo';

export interface Props {
  baseDaUrl: string;
  withLink?: boolean;
  className?: string;
}

const SisuPageLogo: FC<Props> = ({ baseDaUrl, className, withLink = true }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const logo = (
    <Logo
      className={className}
      size={isMobile ? 'tiny' : 'small'}
      textColor={isMobile ? 'black' : 'white'}
    />
  );
  if (withLink) {
    return (
      <a
        href={sanitizeHref(baseDaUrl)}
        title={t('sisu.logo.title')}
        aria-label={t('sisu.logo.title')}
      >
        {logo}
      </a>
    );
  }
  return logo;
};
SisuPageLogo.displayName = 'SisuPageLogo';

export default SisuPageLogo;
